import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    "Supabase env vars missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in uproot-main/frontend/.env"
  );
}

async function safeSupabaseFetch(input, init) {
  const isRequestLike =
    input &&
    typeof input === "object" &&
    typeof input.url === "string" &&
    typeof input.method === "string";

  if (isRequestLike) {
    const request = typeof input.clone === "function" ? input.clone() : input;
    const method = request.method || "GET";
    const headers = request.headers
      ? Object.fromEntries(new Headers(request.headers).entries())
      : {};

    let body = init?.body;
    if (body == null && method !== "GET" && method !== "HEAD") {
      try {
        if (typeof request.text === "function") {
          body = await request.text();
        }
      } catch {
        body = undefined;
      }
    }

    return fetch(request.url, {
      method,
      headers,
      body,
      ...init,
    });
  }

  return fetch(input, init);
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "", {
  auth: {
    detectSessionInUrl: false,
    autoRefreshToken: false,
  },
  global: {
    fetch: safeSupabaseFetch,
  },
});
